var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 25.714,
    viewBox: "620 366.166 18 25.714",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 2",
    transform: "translate(4159 936.166)",
    clipPath: "url(\"#a\")"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon feather-smartphone"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3536.429-570h12.858a2.571 2.571 0 0 1 2.571 2.571v20.572a2.571 2.571 0 0 1-2.571 2.571h-12.858a2.571 2.571 0 0 1-2.571-2.571v-20.572a2.571 2.571 0 0 1 2.571-2.571Z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2,
    stroke: "#000",
    fill: "transparent",
    "data-name": "Path 19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3530-549.429h0",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2,
    stroke: "#000",
    fill: "transparent",
    "data-name": "Path 20"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0V0z",
    "data-name": "Rectangle 81",
    transform: "translate(-3544 -571)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.e1dc8f9aa3b9eceda1ca2f3cfe731260.svg";
export { ForwardRef as ReactComponent };